import type { Me } from "../api.js";

export function paymentWorkflowAccess(me: Me | null) {
  const held = new Set(me?.capabilities ?? []);
  const staff = me?.booking.staff === true;
  const manageAll = staff && held.has("lesson_blocks.manage.all");
  const manageBlocks = manageAll || (staff && held.has("lesson_blocks.manage.own_students"));
  const ownProviderId = me?.booking.providerId ?? null;
  return {
    lessons: staff && held.has("payments.manage"),
    blocks: staff && (manageBlocks || (me?.roles.includes("tutor") === true && ownProviderId !== null)),
    manageAll,
    manageBlocks,
    ownProviderId,
  };
}

export type BlockSaleForm = "managed" | "five-credit";

/**
 * Which block-sale form this account gets for one identified private student,
 * or null for none. The Diary button and BlockSaleWorkflow both ask this, so a
 * button can never open a refusal.
 *
 * `canManage` is the host's appointment authority, and only the managed form
 * depends on it. The five-credit form is a tutor's inherent own-student right
 * and is deliberately not gated on canManage, booking.staff or role, exactly as
 * the Diary's original "Add 5 credits" was. The Hub and FastAPI re-check both.
 */
export function blockSaleForm(me: Me | null, { canManage = true }: { canManage?: boolean } = {}): BlockSaleForm | null {
  if (me === null) return null;
  if (canManage && paymentWorkflowAccess(me).manageBlocks) return "managed";
  const ownProviderId = me.booking.providerId ?? null;
  if (ownProviderId !== null && !me.capabilities.includes("lesson_blocks.manage.all")) return "five-credit";
  return null;
}

export function logPaymentHref(studentId: string): string {
  return `/payments/log?student=${encodeURIComponent(studentId)}`;
}
